if (typeof ExitOfferPopup !== 'function') {
    class ExitOfferPopup extends HTMLElement {
    constructor() {
    super();

    this.keys = {
    dismissedAt: 'exit-offer-dismissed-at',
    subscribed: 'exit-offer-subscribed',
    shownSession: 'exit-offer-shown-session',
    deadline: 'exit-offer-deadline'
    };

    this.options = Object.assign(
    {
    timerSeconds: 300,
    cooldownDays: 7,
    desktopExitIntent: true,
    mobileScrollUp: true,
    minDepthPercent: 15,
    minTimeOnPage: 10,
    designMode: false,
    posted: false
    },
    this.safeParse(this.dataset.options)
    );

    this.open = false;
    this.loadedAt = Date.now();
    this.lastScrollY = window.scrollY;
    this.tickHandle = null;

    this.clock = this.querySelector('[data-exit-offer-clock]');
    this.emailInput = this.querySelector('.exit-offer__input');
    this.errorBox = this.querySelector('[data-exit-offer-error]');
    this.form = this.querySelector('form');
    }

    connectedCallback() {
    this.querySelectorAll('[data-exit-offer-close]').forEach((el) => {
    el.addEventListener('click', () => this.dismiss());
    });

    document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && this.open) this.dismiss();
    });

    if (this.form) {
    this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    /* Nach einer Anmeldung leitet Shopify mit ?customer_posted=true zurueck.
       Der Hash sagt, welches Formular es war. */
    const cameBack = /[?&]customer_posted=true/.test(window.location.search);
    const fromExitOffer = cameBack && window.location.hash === '#exit-offer-form';

    /* Nach einer Anmeldung ueber dieses oder ein anderes Formular (nicht das Welcome-Popup) darf das
       Welcome-Popup nicht auf der Folgeseite aufgehen und dem Abonnenten erneut das Formular zeigen. */
    if (cameBack && window.location.hash.indexOf('popup-newsletter-signup') === -1) {
    this.store('newsletter-popup-success-shown', 'true');
    }

    /* Anmeldung ueber ein anderes Formular (Welcome-Popup, Footer, alter Banner):
       15%-Popup dauerhaft sperren, damit niemand zwei Angebote bekommt. */
    if (cameBack && !fromExitOffer) {
    this.store(this.keys.subscribed, '1');
    }

    /* Eigene Anmeldung: Erfolgsmeldung "Fast fertig, bestaetige die E-Mail" mit Timerleiste zeigen.
       Der Liquid-Wert options.posted ist ausserhalb des Formulars immer false, deshalb ueber die URL. */
    if (this.options.posted || fromExitOffer) {
    this.store(this.keys.subscribed, '1');
    this.show({ withTimer: true, success: true });
    return;
    }

    if (this.options.designMode) {
    this.show({ withTimer: true });
    return;
    }

    if (!this.eligible()) return;

    this.armTriggers();
    }

    safeParse(raw) {
    try {
    return JSON.parse(raw || '{}');
    } catch (error) {
    return {};
    }
    }

    read(key) {
    try {
    return window.localStorage.getItem(key);
    } catch (error) {
    return null;
    }
    }

    store(key, value) {
    try {
    window.localStorage.setItem(key, value);
    } catch (error) {
    /* storage blocked */
    }
    }

    eligible() {
    if (this.read(this.keys.subscribed)) return false;
    if (this.read('newsletter-popup-subscribed') || this.read('arteamony_eib_subscribed')) return false;

    const dismissedAt = parseInt(this.read(this.keys.dismissedAt) || '0', 10);
    if (dismissedAt) {
    const cooldownMs = this.options.cooldownDays * 24 * 60 * 60 * 1000;
    if (Date.now() - dismissedAt < cooldownMs) return false;
    }

    try {
    if (window.sessionStorage.getItem(this.keys.shownSession)) return false;
    } catch (error) {
    /* storage blocked */
    }

    return true;
    }

    optInSeen() {
    /* Opt-in-Popup in dieser Sitzung geoeffnet oder in den letzten Tagen geschlossen */
    try {
    if (window.sessionStorage.getItem('newsletter-popup-triggered') === 'true') return true;
    } catch (error) {
    /* storage blocked */
    }
    const closedAt = parseInt(this.read('newsletter-popup-dismissed-at') || '0', 10);
    return !!closedAt && Date.now() - closedAt < this.options.cooldownDays * 24 * 60 * 60 * 1000;
    }

    blockedRightNow() {
    if (Date.now() - this.loadedAt < this.options.minTimeOnPage * 1000) return true;

    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && this.options.minDepthPercent > 0) {
    const depth = (window.scrollY / scrollable) * 100;
    if (depth < this.options.minDepthPercent) return true;
    }

    // Reihenfolge: erst das Opt-in-Popup (10 %), danach das Exit-Popup (15 %) - nie davor.
    if (!this.optInSeen()) return true;

    // Mindestabstand nach dem Schliessen des Opt-in-Popups, damit nicht zwei Popups direkt aufeinander folgen
    const optInClosedAt = parseInt(this.read('newsletter-popup-dismissed-at') || '0', 10);
    if (optInClosedAt && Date.now() - optInClosedAt < 20000) return true;

    // Do not stack on top of the cookie banner or the newsletter popup
    const cmp = document.querySelector('pandectes-cmp');
    if (cmp && cmp.shadowRoot && cmp.shadowRoot.querySelector('#pandectes-banner')) return true;

    const newsletter = document.querySelector('newsletter-popup modal-box');
    if (newsletter && (newsletter.classList.contains('active') || window.getComputedStyle(newsletter).display !== 'none')) return true;

    if (document.querySelector('cart-drawer[open], [data-cart-drawer].is-open')) return true;

    return false;
    }

    armTriggers() {
    if (this.options.desktopExitIntent) {
    document.addEventListener('mouseout', (event) => {
    if (event.clientY > 0 || event.relatedTarget) return;
    this.maybeShow();
    });
    }

    if (this.options.mobileScrollUp) {
    window.addEventListener(
    'scroll',
    () => {
    const current = window.scrollY;
    const delta = this.lastScrollY - current;
    this.lastScrollY = current;
    if (delta > 90 && current > 200) this.maybeShow();
    },
    { passive: true }
    );
    }

    // Android/iOS back gesture
    window.addEventListener('popstate', () => this.maybeShow());
    }

    maybeShow() {
    if (this.open) return;
    if (!this.eligible()) return;
    if (this.blockedRightNow()) return;
    this.show({ withTimer: true });
    }

    show({ withTimer, success }) {
    this.open = true;
    this.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    try {
    window.sessionStorage.setItem(this.keys.shownSession, '1');
    } catch (error) {
    /* storage blocked */
    }

    /* Erfolgsmeldung nach der Anmeldung: Timerleiste bleibt sichtbar und laeuft weiter,
       das Popup schliesst sich bei 0:00 aber nicht von selbst. */
    this.successMode = !!success;

    /* Reihenfolge: Das Welcome-Popup (Opt-in) darf nach dem 15%-Popup nicht mehr von selbst aufgehen. */
    if (!success) {
    this.store('newsletter-popup-dismissed-at', String(Date.now()));
    try {
    window.sessionStorage.setItem('newsletter-popup-triggered', 'true');
    } catch (error) {
    /* storage blocked */
    }
    }

    if (withTimer) this.startTimer();

    window.setTimeout(() => {
    if (this.emailInput && window.innerWidth >= 750) this.emailInput.focus();
    }, 120);

    document.dispatchEvent(new CustomEvent('exit-offer:shown'));
    }

    startTimer() {
    let deadline = parseInt(this.read(this.keys.deadline) || '0', 10);
    if (!deadline || deadline < Date.now()) {
    deadline = Date.now() + this.options.timerSeconds * 1000;
    this.store(this.keys.deadline, String(deadline));
    }

    const tick = () => {
    const remaining = Math.max(0, Math.round((deadline - Date.now()) / 1000));
    if (this.clock) {
    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    this.clock.textContent = minutes + ':' + String(seconds).padStart(2, '0');
    }
    if (remaining <= 0) {
    window.clearInterval(this.tickHandle);
    if (!this.successMode) this.dismiss();
    }
    };

    tick();
    this.tickHandle = window.setInterval(tick, 1000);
    }

    onSubmit(event) {
    if (!this.emailInput) return;
    const value = this.emailInput.value.trim();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
    if (!valid) {
    event.preventDefault();
    if (this.errorBox) this.errorBox.hidden = false;
    this.emailInput.focus();
    return;
    }
    if (this.errorBox) this.errorBox.hidden = true;
    this.store(this.keys.subscribed, '1');
    }

    dismiss() {
    this.open = false;
    this.hidden = true;
    document.documentElement.style.overflow = '';
    if (this.tickHandle) window.clearInterval(this.tickHandle);
    if (!this.read(this.keys.subscribed)) {
    this.store(this.keys.dismissedAt, String(Date.now()));
    }
    document.dispatchEvent(new CustomEvent('exit-offer:dismissed'));
    }
    }

    customElements.define('exit-offer-popup', ExitOfferPopup);
    }
